<div *ngIf="mainTitle" class="main-title">{{mainTitle}}</div>
<div class="no-results-container empty-state">
  <u-icon
    class="no-results-img"
    [model]="{
      type: 'img',
      value: {
        lightUrl: '/assets/bar/widgets/' + imgModel?.lightUrl + '.svg',
        darkUrl: '/assets/bar/widgets/' + imgModel?.darkUrl + '.svg'
      }
    }"
    [inSvg]="inSvg"
  ></u-icon>
  <h3 class="small-title">{{ title }}</h3>
  <h3 class="small-sub-title">{{ subtitle }}</h3>
</div>
